/**
 * BYO API key management — localStorage backed with useSyncExternalStore support.
 */

const STORAGE_KEY = "dressingroom-api-key";
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((fn) => fn());
}

export function readApiKey(): string | null {
  if (typeof window === "undefined") return null;
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function saveApiKey(key: string): void {
  if (typeof window === "undefined") return;
  const trimmed = key.trim();
  if (!trimmed) return;
  localStorage.setItem(STORAGE_KEY, trimmed);
  emit();
}

export function clearApiKey(): void {
  if (typeof window === "undefined") return;
  localStorage.removeItem(STORAGE_KEY);
  emit();
}

export function maskApiKey(key: string): string {
  if (!key || key.length < 8) return key;
  return key.slice(0, 3) + "…" + key.slice(-4);
}

export function isValidApiKey(key: string): boolean {
  return typeof key === "string" && key.startsWith("sk-") && key.length >= 10;
}

export function subscribeApiKey(callback: () => void): () => void {
  listeners.add(callback);
  if (typeof window !== "undefined") {
    window.addEventListener("storage", callback);
  }
  return () => {
    listeners.delete(callback);
    if (typeof window !== "undefined") {
      window.removeEventListener("storage", callback);
    }
  };
}

export function getApiKeySnapshot(): string | null {
  return readApiKey();
}

export function serverApiKeySnapshot(): string | null {
  return null;
}
